/* Benefits page: auto-built category menu, smooth scroll with sticky-header offset + active state */
(function () {
  if (window.__benefitsPageInit) return;
  window.__benefitsPageInit = true;

  var observer = null;

  function headerOffset() {
    var h = document.querySelector('.shopify-section-group-header-group, #shopify-section-mana-header, header');
    if (!h) return 0;
    var pos = getComputedStyle(h).position;
    var r = h.getBoundingClientRect();
    return (pos === 'fixed' || pos === 'sticky') ? Math.max(0, r.bottom) : 0;
  }

  function setOffsetVar() {
    document.documentElement.style.setProperty('--benefits-scroll-offset', (headerOffset() + 16) + 'px');
  }

  function buildMenus() {
    var cats = Array.prototype.slice.call(document.querySelectorAll('[data-benefits-category]'));
    var lists = document.querySelectorAll('[data-benefits-menu-list]');
    Array.prototype.forEach.call(lists, function (list) {
      list.innerHTML = '';
      cats.forEach(function (cat) {
        if (!cat.id) return;
        var li = document.createElement('li');
        li.className = 'benefits-menu__item';
        var a = document.createElement('a');
        a.className = 'benefits-menu__link';
        a.href = '#' + encodeURIComponent(cat.id);
        a.setAttribute('data-benefits-link', '');
        var iconUrl = cat.getAttribute('data-menu-icon');
        if (iconUrl) {
          var img = document.createElement('img');
          img.className = 'benefits-menu__icon';
          img.src = iconUrl.indexOf('//') === 0 ? 'https:' + iconUrl : iconUrl;
          img.alt = ''; img.width = 50; img.height = 35;
          a.appendChild(img);
        }
        var label = document.createElement('span');
        label.className = 'benefits-menu__label';
        label.textContent = cat.getAttribute('data-menu-label') || '';
        a.appendChild(label); li.appendChild(a); list.appendChild(li);
      });
    });
    initActive();
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[data-benefits-link]');
    if (!link) return;
    var id = decodeURIComponent((link.getAttribute('href') || '').slice(1));
    var target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 16;
    window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  });

  function initActive() {
    if (observer) { observer.disconnect(); observer = null; }
    var links = Array.prototype.slice.call(document.querySelectorAll('a[data-benefits-link]'));
    if (!links.length || !('IntersectionObserver' in window)) return;
    var map = {};
    links.forEach(function (l) {
      var el = document.getElementById(decodeURIComponent(l.getAttribute('href').slice(1)));
      if (el) (map[el.id] = map[el.id] || []).push(l);
    });
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        links.forEach(function (l) { l.classList.remove('is-active'); });
        (map[en.target.id] || []).forEach(function (l) { l.classList.add('is-active'); });
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    Object.keys(map).forEach(function (id) { observer.observe(document.getElementById(id)); });
  }

  /* Theme editor: rebuild when sections are added, removed, re-rendered or reordered */
  var rebuildTimer;
  function scheduleBuild() { clearTimeout(rebuildTimer); rebuildTimer = setTimeout(buildMenus, 50); }
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (ev) {
    document.addEventListener(ev, scheduleBuild);
  });

  setOffsetVar();
  window.addEventListener('resize', setOffsetVar);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildMenus); else buildMenus();
})();




